var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { RestService } from "../RestService";
const URL = "/content";
export class ContentApi extends RestService {
    getAll(params, active) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.httpClient.get(URL, Object.assign(Object.assign({}, params), { active }));
            if (res.ok) {
                return res.data;
            }
            else {
                return null;
            }
        });
    }
    getOne(contentId) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.httpClient.get(`${URL}/${contentId}`);
            if (res.ok) {
                return res.data;
            }
            else {
                return null;
            }
        });
    }
    createContent(content) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.httpClient.post(URL, content, this.headers.multipart);
            if (res.ok)
                return res.data;
            return null;
        });
    }
    update(content) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.httpClient.put(URL, content, this.headers.multipart);
            console.log(URL, 'nyan');
            return res.ok;
        });
    }
    delete(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${URL}/${id}`;
            const res = yield this.httpClient.delete(url);
            return res.ok;
        });
    }
    deleteActivities(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.httpClient.put(`${URL}/deleteActivities`, { ids });
            return res.ok;
        });
    }
    getFavorites(contentIds, dayProgramIds) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = "favorites";
            const res = yield this.httpClient.get(url, { contentIds, dayProgramIds });
            if (res.ok)
                return res.data;
            return null;
        });
    }
    updateActivity(ids, newStatus) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.httpClient.put(`${URL}/activity`, { ids, newStatus });
            return res.ok;
        });
    }
    updateLikes(id, isLike) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.httpClient.put(`${URL}/updateLikes`, { id, isLike });
            return res.ok;
        });
    }
    updateHits(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.httpClient.put(`${URL}/updateHits`, { id });
            return res.ok;
        });
    }
}
//# sourceMappingURL=ContentApi.js.map